module.exports = __webpack_public_path__ + "img/together_we_care_logo.54e9c46d.png";